var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('EmptyStateImg'),_c('div',{staticClass:"empty-text"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("no_label_sets_found"))+" ")]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.$t("no_label_sets_found_description"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }